import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
interface StickyNavBarProps {
  prevUrl?: string;
  nextUrl: string;
  continueDisabled?: boolean;
  openInNewTabUrl?: string;
}
export default function StickyNavBar(t0) {
  const $ = _c(41);
  const {
    prevUrl,
    nextUrl,
    continueDisabled,
    openInNewTabUrl
  } = t0;
  let t1;
  if ($[0] !== openInNewTabUrl) {
    t1 = openInNewTabUrl && <a href={openInNewTabUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 text-[10px] sm:text-xs text-uzh-blue hover:text-uzh-blue/80 transition-colors whitespace-nowrap" title={"In neuem Tab \xF6ffnen"}><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg><span className="hidden sm:inline">In neuem Tab öffnen</span><span className="sm:hidden">Öffnen</span></a>;
    $[0] = openInNewTabUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const newTabLink = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-[7px] sm:text-[8px] text-gray-500 truncate" suppressHydrationWarning={true}>© {new Date().getFullYear()} Teaching Center, Department of Finance, University of Zurich</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const copyright = t2;
  let t3;
  if ($[3] !== prevUrl) {
    t3 = prevUrl && <Link href={prevUrl} className="inline-block bg-gray-300 text-gray-700 px-4 py-1.5 text-sm sm:px-4 sm:py-1.5 sm:text-sm rounded-lg hover:bg-gray-400 transition-colors font-medium shadow-sm">Zurück</Link>;
    $[3] = prevUrl;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const backButton = t3;
  let t4;
  if ($[5] !== continueDisabled || $[6] !== nextUrl) {
    t4 = continueDisabled ? <span className="inline-block bg-primary-100/50 text-white px-4 py-1.5 text-sm sm:px-4 sm:py-1.5 sm:text-sm rounded-lg font-medium cursor-not-allowed">Weiter</span> : <Link href={nextUrl} className="inline-block bg-primary-100 text-white px-4 py-1.5 text-sm sm:px-4 sm:py-1.5 sm:text-sm rounded-lg hover:bg-primary-80 transition-colors font-medium shadow-sm">Weiter</Link>;
    $[5] = continueDisabled;
    $[6] = nextUrl;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const nextButton = t4;
  if (!openInNewTabUrl) {
    let t5;
    if ($[8] !== backButton) {
      t5 = <div>{backButton}</div>;
      $[8] = backButton;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== nextButton) {
      t6 = <div>{nextButton}</div>;
      $[10] = nextButton;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
      t7 = <div className="sticky bottom-0 z-30 -mx-2 sm:-mx-3 bg-white border-t shadow-[0_-2px_8px_rgba(0,0,0,0.08)]"><div className="flex items-center justify-between px-2 sm:px-3 py-1.5">{t5}{t6}</div></div>;
      $[12] = t5;
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    return t7;
  }
  let t5;
  if ($[15] !== backButton) {
    t5 = <div>{backButton}</div>;
    $[15] = backButton;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== nextButton) {
    t6 = <div>{nextButton}</div>;
    $[17] = nextButton;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div className="flex items-center justify-between px-2 py-1.5">{t5}{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== newTabLink) {
    t8 = <div className="flex items-center justify-between px-2 py-0.5 border-t border-gray-100">{newTabLink}{copyright}</div>;
    $[22] = newTabLink;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = <div className="sm:hidden">{t7}{t8}</div>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== backButton) {
    t10 = <div className="flex-shrink-0">{backButton}</div>;
    $[27] = backButton;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== newTabLink) {
    t11 = <div className="flex flex-col ml-3">{newTabLink}{copyright}</div>;
    $[29] = newTabLink;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex-1" />;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== nextButton) {
    t13 = <div className="flex-shrink-0">{nextButton}</div>;
    $[32] = nextButton;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t13) {
    t14 = <div className="hidden sm:flex items-center px-3 py-1.5">{t10}{t11}{t12}{t13}</div>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t14 || $[39] !== t9) {
    t15 = <div className="sticky bottom-0 z-30 -mx-2 sm:-mx-3 bg-white border-t shadow-[0_-2px_8px_rgba(0,0,0,0.08)]">{t9}{t14}</div>;
    $[38] = t14;
    $[39] = t9;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
}